import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconReplay5Style0 = cosmosIconCss;

const CosmosIconReplay5$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconReplay5 extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '89074b19e99da2fc06f9d9f0fab1044aec2cb964', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '70a56611099b02c16e06ef3f791f99205afdbbd9', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '8a931176ea95d28e4bf56e74ac202a8c8a85254e', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M9 6.472h4.628a5.11 5.11 0 0 1 5.162 4.824 4.852 4.852 0 0 1-1.362 3.562 5 5 0 0 1-2.841 1.493.509.509 0 0 1-.587-.5v-.532a.51.51 0 0 1 .425-.493c.73-.137 1.4-.49 1.926-1.015a3.323 3.323 0 0 0 .939-2.473 3.6 3.6 0 0 0-3.662-3.362H9v2.3a.5.5 0 0 1-.854.352L5.114 7.576a.5.5 0 0 1 0-.706l3.033-3.024A.5.5 0 0 1 9 4.2v2.272Zm2.54 10.433c.315-.281.493-.684.489-1.105a1.33 1.33 0 0 0-1.35-1.41 1.467 1.467 0 0 0-.64.14V14h1.53a.231.231 0 0 0 .24-.24v-.54a.23.23 0 0 0-.24-.24h-2.42a.23.23 0 0 0-.24.24v2.01a.231.231 0 0 0 .24.24h.76a.213.213 0 0 0 .15-.07.475.475 0 1 1 .33.81.42.42 0 0 1-.39-.23.223.223 0 0 0-.2-.15h-.74a.191.191 0 0 0-.21.24c.107.749.788 1.28 1.54 1.2.418.05.838-.084 1.152-.365Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconReplay5Style0; }
}, [1, "cosmos-icon-replay-5", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-replay-5"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-replay-5":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconReplay5$1);
            }
            break;
    } });
}

const CosmosIconReplay5 = CosmosIconReplay5$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconReplay5, defineCustomElement };
